var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-testing-page-db-update"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"loader-svg"},[_c('div',{staticClass:"logo-animate"},[_c('img',{attrs:{"src":_vm.logoMain,"alt":""}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }